<template>
  <span>
    <el-button type="warning" size="mini" @click="showImportBox" style="margin-left: 10px">{{ buttonName }}</el-button>
  </span>
</template>

<script>
import {
  importArticle
} from "@/api/article";

export default {
  name: "importWechatArticle",
  props: {
    buttonName: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "app"
    },
    listContentLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      importBoxVisible: false,
      importForm: {
        link: ''
      },
      theType: this.type,
    };
  },
  methods: {
    showImportBox() {
      this.$prompt('请输入文章链接', '导入微信文章', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(({value}) => {
        // value
        this.$emit('listContentLoadingFun', true)
        this.$notify({
          title: '提示',
          message: '正在导入中请耐心等待...',
          type: 'warning'
        });
        importArticle({link: value, type: this.theType}).then((res) => {
          this.$emit('listContentLoadingFun', false)
          if (res.code != 1) {
            this.$notify.error({title: '失败', message: res.message});
          } else {
            this.$notify.success({title: '成功', message: '导入成功'});
          }
        }).cache(() => {
          this.$emit('listContentLoadingFun', false)
          this.$notify.error({title: '失败', message: '导入失败请联系技术部'});
        })
      }).catch(() => {
        // 取消输入
      });
    }
  }
}
</script>